(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBBS(wrap) {
      if (!wrap || wrap.dataset.bbsInit === '1') return;
      wrap.dataset.bbsInit = '1';

      const moneyFormat = wrap.dataset.currencyFormat || '${{amount}}';
      const cards = wrap.querySelectorAll('.bbs-bundle-card');

      // Default state for each slot (initialize with first product variant)
      // We'll store current selections per slot globally for this BBS instance
      const slotSelections = {}; // { slotIdx: { variantId, price, title, img } }

      const firstProduct = wrap.querySelector('.bbs-slot-option');
      if (!firstProduct) return;

      function formatMoney(cents) {
        if (typeof cents === 'string') cents = parseInt(cents);
        var amount = (cents / 100).toFixed(2);
        var amountNoDecimals = Math.round(cents / 100);
        var amountWithComma = amount.replace('.', ',');
        var amountNoDecimalsWithComma = amountNoDecimals.toString().replace('.', ',');

        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithComma)
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimalsWithComma);
      }

      function updatePrices() {
        cards.forEach((card) => {
          const qty = parseInt(card.dataset.qty);
          const discount = parseInt(card.dataset.discount || 0);

          let totalOrig = 0;
          for (let i = 1; i <= qty; i++) {
            const slot = card.querySelector(`.bbs-slot-item[data-slot-id="${i}"]`);
            if (slot) {
              const price = parseInt(slot.dataset.basePrice || firstProduct.dataset.price);
              totalOrig += price;
            } else {
              // If slot not rendered yet in DOM but needed for calc
              totalOrig += parseInt(firstProduct.dataset.price);
            }
          }

          const totalFinal = Math.round(totalOrig * (1 - discount / 100));

          const finalEl = card.querySelector('[data-bundle-price-final]');
          const origEl = card.querySelector('[data-bundle-price-orig]');

          if (finalEl) finalEl.textContent = formatMoney(totalFinal);
          if (origEl) {
            origEl.textContent = discount > 0 ? formatMoney(totalOrig) : '';
            origEl.style.display = discount > 0 ? 'block' : 'none';
          }
        });
      }

      function selectBundle(targetCard) {
        cards.forEach((card) => {
          card.classList.toggle('bbs-bundle-card--selected', card === targetCard);
        });
        updatePrices();
      }

      function updateSlotUI(slot, variantData) {
        slot.dataset.variantId = variantData.id;
        slot.dataset.basePrice = variantData.price;
        slot.querySelector('.bbs-slot-name').textContent = variantData.title;
        slot.querySelector('.bbs-slot-img-wrap img').src = variantData.img;
        updatePrices();
      }

      // Init logic
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('.bbs-slot-dropdown-wrap')) return;
          selectBundle(card);
        });

        const slots = card.querySelectorAll('.bbs-slot-item');
        slots.forEach((slot) => {
          const trigger = slot.querySelector('.bbs-slot-trigger');
          const options = slot.querySelectorAll('.bbs-slot-option');

          // Initialize slot data if not set
          if (!slot.dataset.variantId) {
            const def = options[0];
            slot.dataset.variantId = def.dataset.variantId;
            slot.dataset.basePrice = def.dataset.price;
          }

          trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

            // Close all other slot triggers in this BBS
            wrap.querySelectorAll('.bbs-slot-trigger').forEach((t) => {
              if (t !== trigger) t.setAttribute('aria-expanded', 'false');
            });

            trigger.setAttribute('aria-expanded', !isExpanded);
          });

          options.forEach((opt) => {
            opt.addEventListener('click', (e) => {
              e.stopPropagation();
              updateSlotUI(slot, {
                id: opt.dataset.variantId,
                price: opt.dataset.price,
                title: opt.dataset.title,
                img: opt.dataset.img,
              });
              trigger.setAttribute('aria-expanded', 'false');
            });
          });
        });
      });

      // Handle clicking outside to close dropdowns
      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) {
          wrap.querySelectorAll('.bbs-slot-trigger').forEach((t) => t.setAttribute('aria-expanded', 'false'));
        }
      });

      updatePrices();
    }

    const wraps = document.querySelectorAll('.bbs-wrap');
    wraps.forEach(initBBS);

    // Re-init for theme editor
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.bbs-wrap').forEach(initBBS);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
